// Librally
// ---------------------------------------
import Swiper, { Navigation, Thumbs } from "swiper";
import "swiper/css";
Swiper.use([Navigation, Thumbs]);

export const webinarSlider = () => {
  window.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".js-thumbslider") != undefined || document.querySelector(".js-thumbslider") != null) {
      const swiper = new Swiper(".js-thumbslider", {
        loop: true,
        spaceBetween: 9,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
      });
      const swiper2 = new Swiper(".js-webinarslider", {
        thumbs: {
          swiper: swiper,
        },
      });
    }
  });
};
